import { Link } from 'react-router-dom';
import { transportData } from './TransportData';

const Footer = () => {
  const { displayWhatsapp, email } = transportData.contact;

  return (
    <footer className="bg-gray-900 px-4 pb-24 pt-10 text-gray-300">
      <div className="mx-auto grid max-w-6xl gap-8 md:grid-cols-3">
        <div>
          <p className="text-lg font-bold text-white">V2V Student Services</p>
          <p className="mt-2 text-sm">
            Safe, affordable student transport and accommodation near VUT, NWU and Sedibeng.
          </p>
        </div>

        <div>
          <p className="font-semibold text-white">Contact</p>
          <p className="mt-2 text-sm">WhatsApp: {displayWhatsapp}</p>
          <p className="mt-1 text-sm">Email: {email}</p>
        </div>

        <nav aria-label="Footer">
          <p className="font-semibold text-white">Links</p>
          <ul className="mt-2 space-y-1 text-sm">
            <li><Link to="/accommodation" className="hover:text-white">Accommodation</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
          </ul>
        </nav>
      </div>

      <p className="mx-auto mt-8 max-w-6xl border-t border-gray-700 pt-4 text-xs text-gray-400">
        © {new Date().getFullYear()} V2V Student Services. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
